function getCartCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
}

function handleUnauthorizedAccess(response) {
    // Si c'est un objet, on le convertit en string pour la vérification
    const text = typeof response === 'object' ? JSON.stringify(response) : response;
    
    if (text.includes('Unauthorized access')) {
        alert('Une erreur technique est survenue. Veuillez réessayer.');
        return true;
    }
    return false;
}

async function addProductToCart(product, quantity) {
    const shopifyRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    const response = await fetch(`${shopifyRoot}cart/add.js`, {
        method: 'POST',
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ 
            id: product, 
            quantity: quantity || 1
        })
    });
    return response;
}

async function clearCart() {
    const shopifyRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    const clearResponse = await fetch(`${shopifyRoot}cart/clear.js`, {
            method: 'POST',
            headers: {'Content-Type': 'application/json','X-Requested-With': 'XMLHttpRequest'}
        });
}

function displayMessage(message, containerId) {
    let messageContainer = document.getElementById(containerId);
  
    if (typeof message === "object") {
        messageContainer.textContent = Object.values(message).join("<br>");
    } else {
        messageContainer.textContent = message;
    }
}

async function fetchCartJS(){
    const shopifyRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    const response = await fetch(`${shopifyRoot}cart.js`)
    const data = await response.json();
    return data.items;
}

async function getCustomerIp(){
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    return data.ip;
}

async function getProductMetaData(productId){
    const shopifyRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    const response = await fetch(`${shopifyRoot}cart?view=meta-data.json`);
    const data = await response.json();
    return data;
}

function generateHash(data, secretKey) {
    const hash = CryptoJS.SHA256(data + secretKey);
    return hash.toString(CryptoJS.enc.Hex);
}

function shouldApplyDiscount(cartItems){
    const subscriptionDiscount = getSessionStorage('subscription_discount');
    let hasDiscount = false;
    if(subscriptionDiscount) {
        hasDiscount = subscriptionDiscount === 'true';
    }

    const subscriptionActive = getSessionStorage('subscription_active');
    let hasSubscriptionActive = false;
    if(subscriptionActive) {
        hasSubscriptionActive = subscriptionActive === '1';
    }
    
    let hasSubscriptionInCart = false;
    cartItems.forEach(item => {
        if (item.shopify_variant_id == 58415247130973 || item.is_subscription || item.variant_id == 58415247130973) {
            hasSubscriptionInCart = true;
        }
    });
    
    const shouldApplyDiscount = hasDiscount || hasSubscriptionInCart || hasSubscriptionActive;
    return shouldApplyDiscount;
}

function hideLoading(idButton, idLoader) {
    const button = document.getElementById(idButton)
    const loader = document.getElementById(idLoader)

    if (button && loader) {
        button.disabled = false;
        button.style.opacity = '1';
        loader.style.display = 'none';
    }
}

function showLoading(idButton, idLoader) {
    const button = document.getElementById(idButton)
    const loader = document.getElementById(idLoader)

    if (button && loader) {
        button.disabled = true;
        button.style.opacity = '0.3';
        loader.style.display = 'block';
    }
}

function setSessionStorage(name, value, maxAge) {
    const data = {
      value: value,
      timestamp: Date.now(),
      maxAge: maxAge * 1000 // Convertir en millisecondes
    };
    sessionStorage.setItem(name, JSON.stringify(data));
}

function getSessionStorage(name) {
    try {
      const item = sessionStorage.getItem(name);
      if (!item) return null;
      
      const data = JSON.parse(item);
      const now = Date.now();
      
      // Vérifier si l'élément a expiré
      if (data.maxAge && (now - data.timestamp) > data.maxAge) {
        sessionStorage.removeItem(name);
        return null;
      }
      
      return data.value;
    } catch (e) {
      console.warn('Erreur lors de la lecture du sessionStorage:', e);
      return null;
    }
}

async function getAccountCustomerData(email, orderId){
    try {
        const apiKeyData = generateTemporalApiKey();
        const payload = {
            email: email.trim(),
            orderId: orderId.trim(),
            apiKey: apiKeyData.apiKey,
            footprint: apiKeyData.footprint,
            timestamp: Date.now(),
            lang: getLanguageCode()
        };

        const apiConfig = getApiConfig();
        const response = await fetch(apiConfig.url_account, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        });

        const text = await response.text();

        if (handleUnauthorizedAccess(text)) {
            window.location.reload();
            return;
        }

        const sessionData = JSON.parse(text);
        
        if (sessionData && !sessionData.error) {
            const dataForSession = {
                data: sessionData,
                email: email,
                orderId: orderId,
                _ts: Date.now()
            };
            setSessionStorage('accountCustomerData', JSON.stringify(dataForSession), 3600);
            return dataForSession;
        }

        return sessionData;
        
    } catch (err) {
        console.error('Erreur getAccountCustomerData:', err);
        return { error: 'Erreur de connexion au serveur' };
    }
}

// Fonction utilitaire pour récupérer les pixels depuis la session
function getPixelConfigsFromSession() {
    const pixelString = getSessionStorage('pixel');
    if (!pixelString) {
        return [];
    }
    
    // Format: "pixelId:accessToken;pixelId2:accessToken2"
    const pixels = pixelString.split(';');
    return pixels.map(pixelPair => {
        const [pixelId, accessToken] = pixelPair.split(':');
        return { pixelId, accessToken };
    }).filter(config => config.pixelId && config.accessToken);
}